module.exports = __webpack_public_path__ + "static/media/salud-svg-green.e95373b1.svg";